import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import _ from 'lodash';

class ParticipantesDatatables extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const event = this.props.participants.selectedEvent;

        if (!event)
            return;

        const events = this.props.events;
        const token = this.props.token;
        const centers = this.props.participants.centers;
        const defaultCenterId = this.props.participants.fortalezaId;

        const editorFields = [
            {
                "label": "CPF",
                "name": "cpf",
                "type": "mask",
                "mask": "000.000.000-00",
            },
            { "label": "Nome", "name": "name" },
            { "label": "Nome no Crachá", "name": "usualName" },
            { "label": "Email", "name": "email" },
            { "label": "Pacote", "name": "pacote" },
            {
                "label": "Status",
                "name": "status",
                "type": "select",
                "options": [
                    {name: 'Pago', id: 'OK'},
                    {name: 'Pendente', id: 'PAYMENT_ERROR'},
                ],
                "optionsPair": {
                    label: 'name',
                    value: 'id'
                }
            },
            {
                "label": "Núcleo",
                "name": "center.id",
                "type": "select",
                "options": _.map(centers, function (center) { return center.toJS(); }),
                "optionsPair": {
                    "label": "name",
                    "value": "id"
                },
                def: defaultCenterId,
            }
        ];

        const editorCreateVisibleColumns = null;
        const editorCreateHiddenColumns = null;
        const editorEditVisibleColumns = null;
        const editorEditHiddenColumns = null;

        const statusRender = function (data, type) {
            if (type === "display") {
                if (data === "OK")
                    return '<span class="bg-primary" style="padding: 1px 3px; color: white; font-weight: bold;"><small>PAGO</small></span>';
                else if (data === "NOT_APPLICABLE")
                    return '<span class="bg-info" style="padding: 1px 3px; color: white; font-weight: bold;"><small>NÃO APLICÁVEL</small></span>';
                else
                    return '<span class="bg-danger" style="padding: 1px 3px; color: white; font-weight: bold;"><small>PENDENTE</small></span>';
            } else {
                return data;
            }
        };

        const presencaRender = function (data, type) {
            if (type === "display") {
                if (data)
                    return '<span class="bg-success" style="padding: 1px 3px; color: white; font-weight: bold;">CONFIRMADO</span>';
                else
                    return '<span class="bg-warning" style="padding: 1px 3px; color: white; font-weight: bold;">À CONFIRMAR</span>';
            } else {
                return data ? "CONFIRMADO" : "À CONFIRMAR";
            }
        };

        const apostilaRender = function (data, type) {
            if (type === "display") {
                if (data && data.length > 0)
                    return '<span class="bg-success" style="padding: 1px 3px; color: white; font-weight: bold;">VINCULADO</span>';
                else
                    return '';
            } else {
                return data && data.length > 0 ? "VINCULADO" : "";
            }
        };

        // IMPORTANTE: Ao mudar índice da coluna bagde, atualizar variável abaixo (zero index)
        const badgeIndex = 3;
        const badgePrintCountIndex = 7;
        const datatablesColumns = [
            { data: "cpf", title: "CPF", render: $.datatable.renders.text() },
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "center.name", title: "Núcleo", render: $.datatable.renders.text() },
            { data: "badge", title: "Credenciamento", render: presencaRender },
            { data: "coursewareId", title: "Apostila", render: apostilaRender },
            { data: "status", title: "Status", render: statusRender },
            { data: "statusOriginal", title: "Status Original", render: statusRender },
            { data: "badgePrintCount", title: "Impressões", render: $.datatable.renders.text() },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/events/' + event.id + '/participants/select',
            createUrl: '/api/events/' + event.id + '/participants/insert',
            editUrl: '/api/events/' + event.id + '/participants/update/_id_',
            removeUrl: '/api/events/' + event.id + '/participants/delete/_id_',
        });

        const buttons = null;

        const order = [[1, "asc"]];
        const pageLength = 100;

        const editorCreateTitle = 'Inserir participante';
        const editorEditTitle = 'Editar participante';
        const editorRemoveTitle = 'Remover participante';
        const editorRemoveMessage = 'Deseja remover este participante?';

        const domClassName = 'events-participants-datatables';
        const title = 'Participantes de ' + event.name;
        const subTitle = 'Gerenciamento';

        const calculateTotal = function (api) {
            let totalConfirmados = 0;
            let total = 0;

            let rows = api.column(badgeIndex).data();

            if (rows) {
                rows.each(function (value) {
                    totalConfirmados = totalConfirmados + (value ? 1 : 0);
                    total++;
                });
            }

            return '<span><strong>Participantes confirmados: ' + totalConfirmados + '/' + total + '</strong></span>';
        };

        const calculateTotalImpressoes = function (api) {
            let totalImpressoes = 0;

            let rows = api.column(badgePrintCountIndex).data();

            if (rows) {
                rows.each(function (value) {
                    totalImpressoes = totalImpressoes + parseInt(value);
                });
            }

            return '<span><strong>Total de impressões: ' + totalImpressoes + '</strong></span>';
        };

        const headerCallback = function(thead, data, start, end, display) {
            let html1 = calculateTotal(this.api());
            let html2 = calculateTotalImpressoes(this.api());
            let html = '<div>' +
                    html1 +
                    '<br />' +
                    html2 +
                    '</div>';

            let rowConfirmados = $('.row-head-confirmados');

            if (rowConfirmados.length === 0) {
                rowConfirmados = $('<div class="row row-head-confirmados"><div class="col-sm-12" style="padding-top: 7px; padding-bottom: 7px;"></div></div>');
                let rowTable = $(thead).parents('.row').first();
                $(rowTable).before(rowConfirmados);
            }

            rowConfirmados.find('div').empty().html(html);
        };

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       order={order}
                       pageLength={pageLength}
                       buttons={buttons}
                       headerCallback={headerCallback}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorCreateVisibleColumns={editorCreateVisibleColumns}
                       editorCreateHiddenColumns={editorCreateHiddenColumns}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorEditVisibleColumns={editorEditVisibleColumns}
                       editorEditHiddenColumns={editorEditHiddenColumns}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

class Participantes extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;
        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PARTICIPANTES)
            return null;

        const participants = props.participants;

        const handleChange = function (e) {
            e.preventDefault();
            props.events.onSelectEventForParticipants(e.target.value);
        };

        let datatables = participants.selectedEvent ? <ParticipantesDatatables {...this.props} /> : null;

        return (
            <div>
                <h3 className="page-header">Selecionar Evento</h3>

                <select value={participants.selectedEvent ? participants.selectedEvent.id : ""}
                        onChange={handleChange}
                        className="form-control">
                    <option key="null" value="">Nenhum</option>
                    {participants.events.map(function (event) {
                        return <option key={event.id} value={event.id}>{event.name}</option>
                    })}
                </select>

                <br />

                {datatables}
            </div>
        );
    }
}

export default Participantes;


// WEBPACK FOOTER //
// src/views/pages/Participantes.jsx